import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Link = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      d="M14 3.5C12.7308 2.2308 10.673 2.2308 9.40381 3.5L10.4645 4.56066C11.1479 3.87724 12.2559 3.87724 12.9393 4.56066C13.6228 5.24408 13.6228 6.35212 12.9393 7.03553L10.1109 9.86396C9.4275 10.5474 8.31946 10.5474 7.63604 9.86396C6.95262 9.18054 6.95262 8.0725 7.63604 7.38909L7.98959 7.03553L6.92893 5.97487L6.57538 6.32843C5.30618 7.59763 5.30618 9.65542 6.57538 10.9246C7.84458 12.1938 9.90237 12.1938 11.1716 10.9246L14 8.09619C15.2692 6.82699 15.2692 4.7692 14 3.5Z"
      fill="currentColor"
    />
    <path
      d="M1.979 11.9853C3.24821 13.2545 5.30599 13.2545 6.5752 11.9853L5.51454 10.9247C4.83112 11.6081 3.72308 11.6081 3.03966 10.9247C2.35624 10.2413 2.35624 9.13321 3.03966 8.4498L5.86809 5.62137C6.55151 4.93795 7.65955 4.93795 8.34296 5.62137C9.02638 6.30479 9.02638 7.41283 8.34296 8.09624L7.98941 8.4498L9.05007 9.51046L9.40362 9.15691C10.6728 7.8877 10.6728 5.82991 9.40362 4.56071C8.13442 3.29151 6.07663 3.29151 4.80743 4.56071L1.979 7.38914C0.709797 8.65834 0.709798 10.7161 1.979 11.9853Z"
      fill="currentColor"
    />
  </Icon>
));

export default Link;
